define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"csi",
	"csi/_base/underscore",
	"csi/html",
	"csi/table/Preferences",
	"csi/xml",
	"ProductSpec/SizeChart",
	"ProductSpec/SizeChart/_SizeChartSubSizeRanges",
	"ProductSpec/SizeChart/_SizeChartTableMixin",
	"ProductSpec/SizeChart/CustomViewSizeChartOptions",
	"ProductSpec/SizeChart/SizeChartTableCustomViewOptionsStore",
	"ProductSpec/SizeChart/SizeChartTableOptionsTab",
	"ProductSpec/SizeChart/Table"
], function(declare,lang,domClass,csi,_,html,Preferences,xml,SizeChart,_SizeChartSubSizeRanges,_SizeChartTableMixin,{SizeChartDimensionFormatType},SizeChartTableCustomViewOptionsStore,SizeChartTableOptionsTab,Table) {

	var	_Preferences = declare(Preferences, {
		constructor: function() {
			this.addCustomOption("sizeChartUnits", SizeChart.valueUnits, false, "SizeChartUnits");
			this.addCustomOption("sizeChartDimensionFormat", SizeChartDimensionFormatType.DEFAULT, false, "SizeChartDimensionFormat");
		}
	});

	return declare([Table,_SizeChartTableMixin], {
		prefClass: _Preferences,

		customViewOptionsComponent: SizeChartTableOptionsTab,
		customViewOptionsStore: SizeChartTableCustomViewOptionsStore,

		// String: selected sub size range
		urlSubSizeRange: csi.EMPTY_URL,

		// Boolean: indicates if table showing single sub-size range
		_bFixedSubSizeRange: false,

		// String: last size range value
		_urlSizeRange: null,
		
		// to show Increment Display: Absolute at the bottom of the table,
		// without having the custom view option to change it
		sizeChartDisplay: "Size Chart Display:Absolute",

		displayTwoDimension: function(/*Node*/scDimension) {
			// summary: returns boolean if the Final Inspection SizeChartDimension is displayed as 2-d matrix
			return false;
		},

		getSubSizeRangeData: function(/*Node?*/node) {
			// summary: return object containing metadata about sub size ranges
			// NOTE: This function assumes given node is child of SizeChartRevision
			var	cache = this.cacheView;
			var	data = this._subSizeRangeData = this._subSizeRangeData || {};

			var fiSizeChart = this.getViewNode();
			if (!fiSizeChart)
				fiSizeChart = this._getSizeChartRevision(node);

			return data[fiSizeChart.$URL] = data[fiSizeChart.$URL] || new _SizeChartSubSizeRanges(this.getSubSizeRanges());
		},

		getBaseSizes: function() {
			// summary: return all base sizes in view
			return this.cacheView.getPathNodes(this.getViewNode(), "Child:FISizeChartSubSizeRanges/Child:BaseSize");
		},

		getSubSizeRanges: function() {
			// summary: return object containing metadata about sub size ranges
			return this.cacheView.getNodes(this.getViewNode().FISizeChartSubSizeRanges);
		},

		// Override same function on ProductSpec.SizeChart._SizeChartTableMixin
		_getSizeChartRevision: function(/*Node?*/node) {
			// summary: return FinalInspectionSizeChart node, which contains informations of SizeChartRevision on a FinalInspection
			// NOTE: This function assumes given node is a child of FinalInspectionSizeChart
			var	cache = this.cacheView;
			node = node || this.getViewNode();

			while (node && (node.$Type != "FinalInspectionSizeChart")) {
				node = cache.getNode(node.__Parent__);
			}

			console.assert(!!node, "_getSizeChartRevision - invalid context node");

			return node;
		}

	});
});